const VideoPopup = () => {

    const videoPopupElements = document.querySelectorAll('.video-popup-js');
    const videoPopupWrapper  = document.querySelector('.video-with-articles-popup');
    const closeVideoPopup    = document.querySelector('.video-with-articles-popup-close');

    if(closeVideoPopup) {
        closeVideoPopup.addEventListener('click', function() {
            if(videoPopupWrapper) {
                videoPopupWrapper.classList.remove('active');

                const iframeRemover = document.querySelector('.video-with-articles-popup-iframe iframe');

                if(iframeRemover) {
                    iframeRemover.remove();
                }
            }
        })
    }

    if(videoPopupElements) {
        videoPopupElements.forEach(function(element) {
            element.addEventListener('click', function(event) {
                event.preventDefault();
    
                const videoUrl = element.getAttribute('href');
                
                try {
                    new URL(videoUrl);
                } catch (e) {
                    console.error('Nieprawidłowy URL');
                    return;
                }
    
                const urlParams = new URLSearchParams(new URL(videoUrl).search);
                const videoId = urlParams.get('v');
                if (!videoId) {
                    console.error('Nieprawidłowy link YouTube');
                    return;
                }
    
                const popup = element.closest('.video-with-articles').querySelector('.video-popup-target');
                if (!popup) {
                    console.error('Nie znaleziono elementu .video-popup-target');
                    return;
                }
    
                const iframeContainer = popup.querySelector('.video-with-articles-popup-iframe');
                if (!iframeContainer) {
                    console.error('Nie znaleziono elementu .video-with-articles-popup-iframe');
                    return;
                }
    
                iframeContainer.innerHTML = '';
    
                const iframe = document.createElement('iframe');
                iframe.setAttribute('width', '560');
                iframe.setAttribute('height', '480');
                iframe.setAttribute('src', 'https://www.youtube.com/embed/' + videoId + '?autoplay=1');
                iframe.setAttribute('frameborder', '0');
                iframe.setAttribute('allow', 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture');
                iframe.setAttribute('allowfullscreen', true);
    
                iframeContainer.appendChild(iframe);
    
                popup.classList.add('active');
            });
        });
    }

}

export default VideoPopup